module.exports = __webpack_public_path__ + "media/images/icon/chevron-down-white-2674c6282a6c0a08154410a4f304a23c.svg";